import parseNotificationMessageMarkdown from './parseNotificationMessageMarkdown'

export default {
  parseNotificationMessageMarkdown,
}
